import React from "react";
import {Autocomplete, Box, TextField} from "@mui/material";
import {NodeField} from "../fields";
import {forms, objects, strings} from "@atttomyx/shared-utils";
import "./offeringForm.css";

const OfferingForm = (props) => {
    const { unique, nodes, data, onChange : onSync, showNode = true } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.category)
            && strings.isNotBlank(modified.type)
            && modified.dollars >= 0 && modified.cents >= 0 && (modified.dollars > 0 || modified.cents > 0)
            && strings.isNotBlank(modified.date);

        onSync(modified);
    };

    return <div className="offering-form">
        {showNode ?
            <div className="field top-margin">
                <NodeField
                    nodes={nodes}
                    value={data.nodeId}
                    onChange={(nodeId) => onChange("nodeId", nodeId)}
                />
            </div> : null}
        <div className={"field" + (!showNode ? " top-margin" : "")}>
            <Autocomplete
                freeSolo={true}
                options={unique.categories}
                inputValue={forms.sanitizeValue(data.category)}
                value={null}
                isOptionEqualToValue={(option, value) => value && strings.equalsIgnoreCase(option, value)}
                renderInput={params =>
                    <TextField
                        required={true}
                        label="Category"
                        {...params}
                    />}
                onInputChange={(event, value, reason) => {
                    if (reason !== "reset") {
                        onChange("category", value);
                    }
                }}
                onChange={(event, value) => onChange("category", value)}
            />
        </div>
        <div className="field">
            <Autocomplete
                freeSolo={true}
                options={unique.types}
                inputValue={forms.sanitizeValue(data.type)}
                value={null}
                isOptionEqualToValue={(option, value) => value && strings.equalsIgnoreCase(option, value)}
                renderInput={params =>
                    <TextField
                        required={true}
                        label="Type"
                        {...params}
                    />}
                onInputChange={(event, value, reason) => {
                    if (reason !== "reset") {
                        onChange("type", value);
                    }
                }}
                onChange={(event, value) => onChange("type", value)}
            />
        </div>
        <Box className="field">
            <TextField
                className="money"
                required={true}
                label="Dollars"
                type="number"
                value={forms.sanitizeValue(data.dollars)}
                error={data.dollars < 0}
                onChange={(event) => onChange("dollars", event.target.value)}
                inputProps={{
                    min: 0,
                }}
            />
            <TextField
                className="money"
                required={true}
                label="Cents"
                type="number"
                value={forms.sanitizeValue(data.cents)}
                error={data.cents < 0 || data.cents > 99}
                onChange={(event) => onChange("cents", event.target.value)}
                inputProps={{
                    min: 0,
                    max: 99,
                }}
            />
        </Box>
        <div className="field">
            <TextField
                required={true}
                label="Date"
                type="date"
                value={forms.sanitizeValue(data.date)}
                onChange={(event) => onChange("date", event.target.value)}
            />
        </div>
    </div>
};

export default OfferingForm;
